<template>
	<div>
		<div class="bodywrap">
			<header>
				<div class="tophead" id="scrollsize">
					<ul>
						<li v-for="(item,index) in headerIntroList">{{item.text}}</li>
					</ul>
				</div>
			</header>

			<div v-if="autoShowInfo.tAutoshowPeriodsOcpc != null">
				<input type="hidden" id="ocpcId" name="ocpcId" :value="autoShowInfo.tAutoshowPeriodsOcpc.ocpcId" />
				<!--   <input type="hidden" id="promotionCanal" name="promotionCanal" :value="autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal" />-->
			</div>
			<input type="hidden" id="showAddress" :value="showAddress">
			<section>
				<div class="banner" id="topSwipers">
					<img v-if="autoShowInfo.headerImg" :src="commmonWebConfig.picHost + autoShowInfo.picUrl + autoShowInfo.headerImg" />
					<!--<mt-swipe :auto="3000">
						<mt-swipe-item v-if="autoShowInfo.headerImg">
							<img :src="commmonWebConfig.picHost + autoShowInfo.picUrl + autoShowInfo.headerImg" />
						</mt-swipe-item>
						<mt-swipe-item v-if="autoShowInfo.headerImgb">
							<img :src="commmonWebConfig.picHost + autoShowInfo.picUrl + autoShowInfo.headerImgb" />
						</mt-swipe-item>
						<mt-swipe-item v-if="autoShowInfo.headerImgc">
							<img :src="commmonWebConfig.picHost + autoShowInfo.picUrl + autoShowInfo.headerImgc" />
						</mt-swipe-item>
					</mt-swipe>-->
				</div>
			</section>
			<div class="pathroom" v-if="autoShowInfo.buyFlowImg">
				<img :src="commmonWebConfig.picHost + autoShowInfo.picUrl + autoShowInfo.buyFlowImg" />
			</div>
			<div class="centerwrap">
				<!--新增需求隐藏倒计时-->
				<!-- <div class="timewrap" v-if="autoShowInfo.showCountdown ==true"> -->
				<div class="timewrap">
					<span class="iconsize"></span>
					<span class="timeNum">
				   	<!-- <em>{{day}}</em>天 -->
						<em>{{hour}}</em>时
						<em>{{min}}</em>分
						<em>{{sec}}</em>秒
						<em>{{msec}}</em>
				   </span>
				</div>
				<div class="formwrap">
					<div class="personticket">
						<div class="numtext">已有<em class="yellow">{{appPersonNum}}</em>人<em>免费领票</em></div>
						<!--<div class="numtext">报名免费领票</div>-->
						<!--<span class="family">报名可免费索取4张家庭套票</span>-->
					</div>
					<form class="indexform">
						<input type="hidden" id="groupbyNum" name="groupbyNum" :value="periodsInfo.id" />
						<div class="sinFormup" id="sinFormapply">
							<em class="icon-arror-l"></em>
							<div @click="getData($event)" class="sinform-text" id="insertCar">请选择意向品牌或车型</div>
							<div class="icon-arror-r"></div>
						</div>
						<div class="sinFormup">
							<em class="sinicon01"></em>
							<input type="tel" class="sinFormuptext" placeholder="联系电话，以便给您门票" name="tel" v-model="phone" maxlength="11" value="" />
						</div>
						<div class="sinFormup">
							<em class="sinicon02"></em>
							<input type="text" class="sinFormuptext" placeholder="您的称呼，以便给您门票" name="username" v-model="username" maxlength="10" value="" />
						</div>
						<div :class="['sinSubmit','btnAction',{'noclick':isclick}]" @click="sinSubmit('#insertCar')">
							<span class="line">
								￥20
								<em></em>
							</span>点击免费领票
						</div>
					</form>
					<!--新增需求隐藏滚动人数-->
					<div class="freetickets">
						<div class="ticketicon"></div>
						<div class="ticketmenu" id="scrollPerson">
							<ul class="clearfix">
								<li class="menuitem clearfix" v-for="(item,index) in applyListMap">
									<span class="scrollname">{{item.username}}</span>
									<span class="scrollphone">{{item.userphone}}</span>
									<span class="scrollticket">{{item.time}}已领票</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="statement">*请放心填写，报名即视为同意<em class="addxydetail" @click="addxydetail">《个人信息保护声明》</em></div>
				</div>
			</div>
			<!--品牌轮播star-->
			<div class="branditemewrap">
				<div class="common-tit">
					<em class="icon-l"></em> 参展品牌
					<em class="icon-r"></em>
				</div>
				<!--品牌轮播-->
				<div class="brandRoom">
					<div class="brand-table" id="brandSwiper">
						<div class="brandlist">
							<mt-swipe :auto="0">
								<mt-swipe-item v-for="n in brandNum">
									<ul>
										<li @click="showbrandmask(commmonWebConfig.picHost+item.brandLogo,item.brandName,item.brandId)" v-for="(item,index) in brandList" v-if="index>=((n-1)*12) && index<=(n*12-1)" class="trackEvent" data-track="carfestivalDetailToutiao-3-brandLink">
											<a href="javascript:void(0);">
												<p>
													<img v-lazy="commmonWebConfig.picHost+item.brandLogo" />
												</p>
												<p class="hot-brand-tit">{{item.brandName}}</p>
											</a>
										</li>
									</ul>
								</mt-swipe-item>
							</mt-swipe>
						</div>
						<div class="hinttext" style="padding-bottom:0 !important;"> 最终参展品牌以实际到场为准</div>
					</div>
				</div>
			</div>
			<!--品牌轮播-end->
		             新增需求隐藏车展亮点模块
			<!--亮点 star-->
			<!--<div class="lightspotwrap clearfix">
				<div class="common-tit different">
					<em class="icon-l"></em> 车展亮点
					<em class="icon-r"></em>
				</div>
				<div class="bright clearfix">
					<ul class="clearfix">
						<li class="img-item01">
							<div class="list-tit">品牌众多</div>
							<div class="list-describe">品牌一站到齐,货比三家</div>
							<span class="list-btn">买车更省心</span>
						</li>
						<li class="img-item02">
							<div class="list-tit">靠谱主办方</div>
							<div class="list-describe">全国百余分站,月均70场</div>
							<span class="list-btn color02">买车更放心</span>
						</li>
						<li class="img-item03">
							<div class="list-tit">价格优惠</div>
							<div class="list-describe">砍价、拼团等多种活动</div>
							<span class="list-btn color03">买车更省钱</span>
						</li>
						<li class="img-item04">
							<div class="list-tit">送双重大礼 </div>
							<div class="list-describe">商家礼展会礼,双重大礼</div>
							<span class="list-btn color04">绝对超值</span>
						</li>
					</ul>
				</div>
			</div>-->
			<!--亮点 end-->
			<div class="presentwrap">
				<div class="presentoverall">
					<div class="present-tit" v-if="periodsInfo.giftPrice">订车送价值<em v-text="periodsInfo.giftPrice"></em>大礼包</div>
					<div class="giftimg">
						<img :src="commmonWebConfig.webCommonUtils+'/img/mapply/threecity/giftbanner.png'" />
					</div>
					<div class="gift-tip">
						*图片仅供参考，礼品以实际到场为准
					</div>
				</div>
				<!--更多好礼 star-->
				<!--0：签到      1：订车    2：抽奖-->
				<div class="moregiftroom">
					<div class="moreText">
						<em class="line01"></em> 更多好礼等你来拿
						<em class="line02"></em>
					</div>
					<div class="scrollimg clearfix" v-for="(item,key,index) in autoShowInfo.maps" v-if="autoShowInfo&&key==1">
						<span class="lefthint">订车有礼</span>
						<div class="scrollmodule swiper-container clearfix" id="giftSwiper">
							<div class="swiper-wrapper">
								<div class="scrollitem swiper-slide" v-for="(item,index) in autoShowInfo.presentList" v-if="autoShowInfo.presentList[index].labelType == 1">
									<div class="scrollicon">
										<img v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName" />
									</div>
									<span class="giftbtn">{{item.text}}</span>
								</div>

							</div>
						</div>
					</div>
					<!--签到礼-->
					<div class="scrollimg clearfix" v-for="(item,key,index) in autoShowInfo.maps" v-if="autoShowInfo&&key==0">
						<span class="lefthint signinTit">签到有礼</span>
						<div class="scrollmodule swiper-container clearfix" id="signinSwiper">
							<div class="swiper-wrapper">
								<div class="scrollitem swiper-slide" v-for="(item,index) in autoShowInfo.presentList" v-if="autoShowInfo.presentList[index].labelType == 0">
									<div class="scrollicon">
										<img v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName" />
									</div>
									<span class="giftbtn">{{item.text}}</span>
								</div>
							</div>
						</div>
					</div>
					<!--签到礼end-->
					<!--分享礼-->
					<div class="scrollimg clearfix" v-for="(item,key,index) in autoShowInfo.maps" v-if="autoShowInfo&&key==2">
						<span class="lefthint sharinTit">抽奖有礼</span>
						<div class="scrollmodule swiper-container clearfix" id="sharSwiper">
							<div class="swiper-wrapper">
								<div class="scrollitem swiper-slide" v-for="(item,index) in autoShowInfo.presentList" v-if="autoShowInfo.presentList[index].labelType == 2">
									<div class="scrollicon">
										<img v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName" />
									</div>
									<span class="giftbtn">{{item.text}}</span>
								</div>

							</div>

						</div>

					</div>
					<!--分享礼end-->
					<div class="hinttext" style="margin-top:0.35rem; padding-bottom:0 !important;"> 图片仅供参考，礼品以实际到场为准</div>
				</div>
			</div>
			<!--更多好礼 end-->

			<!--交通指南-->
			<div class="traffic">
				<div class="common-tit">
					<em class="icon-l"></em> 交通指南
					<em class="icon-r"></em>
				</div>
				<div class="addmsgwrap">
					<div class="addressimg" v-if="periodsInfo.
venuesImg">
						<img :src="commmonWebConfig.picHost + autoShowInfo.picUrl + periodsInfo.
venuesImg" />
					</div>
					<div class="addresswrap" :style="{'margin-top': periodsInfo.venuesImg ? '-0.4rem' : ''}">
						<div class="describe">{{periodsInfo.address}}</div>
						<div class="addText" v-if="periodsInfo&&periodsInfo.trafficRoutesMapList" v-for="item in periodsInfo.trafficRoutesMapList">
							<div v-for="(val, key, index) in item">
								<em v-if="key=='1、自驾线路'" class="addicon01"></em>
								<em v-if="key=='2、公交出行'" class="addicon02"></em>
								<em v-if="key=='3、地铁线路'" class="addicon03"></em>
								<em v-if="key=='4、市外线路'" class="addicon02"></em> {{key.split('、')[1]}}
								<p>
									{{val}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--团车保障-->
			<div class="safeguard">
				<div class="common-tit">
					<em class="icon-l"></em> 服务保障
					<em class="icon-r"></em>
				</div>
				<div class="servicewrap clearfix">
					<ul>
						<li class="clearfix">
							<div class="serve-border">
								<div class="clearfix serve-icon-warp">
									<span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi1"></em>
                            </span>
									<em class="fl serve-icon-arr"></em>
								</div>
								<div class="serve-txt">
									<p class="serve-txt-tit">品牌齐全</p>
									<p class="serve-txt-gary">涵盖了自主、合资、</p>
									<p class="serve-txt-gary">进口等众多热销品牌</p>
								</div>
							</div>
						</li>
						<li class="clearfix">
							<div class="serve-border">
								<div class="clearfix serve-icon-warp">
									<span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi2"></em>
                            </span>
									<em class="fl serve-icon-arr"></em>
								</div>
								<div class="serve-txt">
									<p class="serve-txt-tit">车型丰富</p>
									<p class="serve-txt-gary">百款车型任您选择</p>
									<p class="serve-txt-gary">看车选车比价一站式完成</p>
								</div>
							</div>
						</li>
						<li class="clearfix">
							<div class="serve-border">
								<div class="clearfix serve-icon-warp">
									<span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi3"></em>
                            </span>
									<em class="fl serve-icon-arr"></em>
								</div>
								<div class="serve-txt">
									<p class="serve-txt-tit">低价优惠</p>
									<p class="serve-txt-gary">车款价格层层对比</p>
									<p class="serve-txt-gary">团车为您提供市场低价</p>
								</div>
							</div>
						</li>
						<li class="clearfix">
							<div class="serve-border">
								<div class="clearfix serve-icon-warp">
									<span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi4"></em>
                            </span>
									<em class="fl serve-icon-arr"></em>
								</div>
								<div class="serve-txt">
									<p class="serve-txt-tit">车源保证</p>
									<p class="serve-txt-gary">优质4s店供车</p>
									<p class="serve-txt-gary">保证您现场买到优质车源</p>
								</div>
							</div>
						</li>
						<li class="clearfix">
							<div class="serve-border">
								<div class="clearfix serve-icon-warp">
									<span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi5"></em>
                            </span>
									<em class="fl serve-icon-arr"></em>
								</div>
								<div class="serve-txt">
									<p class="serve-txt-tit">服务保证</p>
									<p class="serve-txt-gary">专属销售
										<span>免费</span>服务</p>
									<p class="serve-txt-gary">力保您省时省力更省心</p>
								</div>
							</div>
						</li>
						<li class="clearfix">
							<div class="serve-border">
								<div class="clearfix serve-icon-warp">
									<span class="fl serve-icon">
                                <em class="serve-icon-zi serve-icon-zi6"></em>
                            </span>
									<em class="fl serve-icon-arr"></em>
								</div>
								<div class="serve-txt">
									<p class="serve-txt-tit">售后保障</p>
									<p class="serve-txt-gary">现场车源全国联保</p>
									<p class="serve-txt-gary">出现问题团车协助解决</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<!--精彩回顾-->
			<div class="splendid">
				<div class="common-tit">
					<em class="icon-l"></em> 精彩回顾
					<em class="icon-r"></em>
				</div>
				<div class="splendidimg clearfix">
					<ul class="clearfix">
						<li v-for="(item,index) in autoShowInfo.lookbackList">
							<img v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName" />
						</li>
					</ul>
				</div>
			</div>
			<!--购车问题-->
			<div class="problem">
				<div class="common-tit">
					<em class="icon-l"></em> 购车问题解答
					<em class="icon-r"></em>
				</div>
				<div class="problemsize">
					<div>
						<em class="simple  query">问</em>
						<span class="whygood">参加车展有什么好处和优惠？</span>
					</div>
					<div class="answerwrap clearfix">
						<div class="leftSize">
							<em class="simple  answer">答</em>
						</div>
						<span class="marked">省心：专职销售跑店省去您的舟车劳顿；省时：将全城
						      低价展现给每一位消费者；省钱：价格优于消费者的自询价格。
						
						</span>
					</div>
				</div>
				<div class="problemsize">
					<div class="distance">
						<em class="simple  query">问</em>
						<span class="whygood">参展VS消费者自购，有何异同？</span>
					</div>
					<div class="answerwrap clearfix">
						<div class="leftSize">
							<em class="simple  answer">答</em>
						</div>

						<span class="marked">相同：标准车型、品牌4S店、标准售后 ；不同：省钱
      省时、增值服务、快乐交友。
						</span>
					</div>
				</div>
				<div class="problemsize">
					<div class="distance">
						<em class="simple  query">问</em>
						<span class="whygood">参加车展要收费吗？</span>
					</div>
					<div class="answerwrap clearfix" style="border-bottom:none;">
						<div class="leftSize">
							<em class="simple  answer">答</em>
						</div>

						<span class="marked"> 全程免费服务，不直接或间接收费，帮您免去4S店收取的部分附加费用。
						</span>
					</div>
				</div>
			</div>
			<!--底部-->
			<div class="copright">
				<p>客服电话：4001-501-501</p>
				<p>团车互联网信息服务（北京）有限公司</p>
				<p>京ICP备12044574号-2</p>
			</div>
			<div class="fixedSubmit" @click="showMask" style="display:none;">
				点击免费领票
			</div>
			<!--弹窗-->
			<div class="pop-mark" v-show="masklayer"></div>
			<div class="shaned" v-show="popshaned">
				<div class="popMask">
					<div class="colsemask" @click="colsemask"></div>
					<div class="leftIcon"></div>
					<div class="rightIcon"></div>
					<form id="btnMask">
						<div class="masksinFormup" id="sinFormapply">
							<em class="icon-arror-l"></em>
							<div @click="getData($event)" class="sinform-text" id="insertCarmask">请选择意向品牌或车型</div>
							<div class="icon-arror-r"></div>
						</div>
						<div class="masksinFormup">
							<em class="maskIcon02"></em>
							<input type="text" placeholder="请输入手机号" class="maskPhone" maxlength="11" v-model="maskPhone" name="maskPhone" id="maskPhone" />
						</div>
						<div class="masksinFormup">
							<em class="maskIcon01"></em>
							<input type="text" placeholder="请输入姓名" class="maskName" v-model="maskName" name="maskName" id="maskName" maxlength="10" />
						</div>

						<div class="maskSubmit" @click="maskSubmit('#insertCarmask')" id="btnmaskSubmit">快速领票</div>
						<div class="maskHint">
							温馨提示：报名即视为同意 <em class="pContent" @click="addxydetail">《个人信息保护声明》</em>
						</div>
					</form>
				</div>
			</div>
			<!--品牌弹窗-->
			<div class="brandwrap" v-show="brandMask">
				<div class="brandMask">
					<div class="closebrandMask" @click="closebrandMask"></div>
					<div class="leftIcon"></div>
					<div class="rightIcon"></div>
					<div class="semicircle">
						<img :src="url" />
					</div>
					<span class="brandTit">快速领票 -{{title}}</span>
					<form class="brandmaskForm">
						<div class="masksinFormup">
							<em class="maskIcon02"></em>
							<input type="text" placeholder="请输入手机号" v-model="brandPhone" class="brandPhone" id="brandPhone" maxlength="11" />
						</div>
						<div class="masksinFormup">
							<em class="maskIcon01"></em>
							<input type="text" placeholder="请输入姓名" v-model="brandName" class="brandName" id="brandName" name="brandName" maxlength="10" />
						</div>
						<div :class="['maskSubmit',{'noclick':isMaskclick}]" id="brandmaskSubmit" @click="brandmaskSubmit">快速领票</div>
						<div class="maskHint">
							温馨提示：报名即视为同意 <em class="pContent" @click="addxydetail">《个人信息保护声明》</em>
						</div>
					</form>
				</div>
			</div>
		</div>
		<!-- <agreementComponent></agreementComponent> -->
		<!--蒙层-->
		<div class="popUp" v-show="isLading"></div>
	</div>
</template>
<style type="text/css">
	.noclick{
		pointer-events: none;
	}
</style>
<script>
	import { Toast } from 'mint-ui';
	//	import Swiper from "swiper";
	export default {
		name: 'login',
		data() {
			return {
				showAddress: '',
				isLading: false, //蒙层
				url: "", //imgurl
				title: '',
				brandId: '', //品牌id
				appPersonNum: '', //报名人数
				masklayer: false, //黑色遮罩层
				popshaned: false, //底部弹窗
				brandMask: false, //品牌弹窗
				phone: "", //手机号
				username: "", //姓名
				headerIntroList: [],
				brandList: [], //品牌
				applyListMap: [], //滚动报名人数
				concentMap: {},
				periodsInfo: {}, //购车问题解答
				cityId: "10",
				maskPhone: "",
				maskName: "",
				beginTime: '', //返回的开始时间
				endTime: '', //返回的结束时间
				hour: 0, //倒计时
				sec: 0,
				day: 0,
				min: 0,
				msec: 0,
				cutTimePre: 0, // 倒计时
				brandNum: 2, //品牌轮播页数，
				autoShowInfo: { //礼品
					presentList: [],
					headerImg: "",
					headerImgb: "",
					headerImgc: "",
					ocpcId: '',
					tAutoshowPeriodsOcpc:null
				},
				brandPhone: '',
				brandName: '',
				cityPy: '',
				periodsType:'1',
				isclick:false,
				isMaskclick:false

			}
		},
		beforeCreate: function() {
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/threecity/index.css"
			});
		},
		mounted: function() {
			var self = this;
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(self.webReady);
			/***统计添加**/
			! function(e, t, n, g, i) {
				e[i] = e[i] || function() {
					(e[i].q = e[i].q || []).push(arguments)
				};
				var n = t.createElement("script");
				var tag = t.getElementsByTagName("script")[0];
				n.async = 1;
				n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g;
				tag.parentNode.insertBefore(n, tag);
			}(window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/
			/*******************/
			! function(g, d, t, e, v, n, s) {
				if(g.gdt) return;
				v = g.gdt = function() {
					v.tk ? v.tk.apply(v, arguments) : v.queue.push(arguments)
				};
				v.queue = [];
				n = d.createElement(t);
				n.async = !0;
				n.src = e;
				s = d.getElementsByTagName(t)[0];
				s.parentNode.insertBefore(n, s);
			}(window, document, 'script', '//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js');
			gdt('init', '1106475123');
			gdt('track', 'PAGE_VIEW');

			//万圣头条
			// (function(root) {
			// 	root._tt_config = true;
			// 	var ta = document.createElement('script'); ta.type = 'text/javascript'; ta.async = true;
			// 	ta.src = 'https://s3.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
			// 	ta.onerror = function () {
			// 		var request = new XMLHttpRequest();
			// 		var web_url = window.encodeURIComponent(window.location.href);
			// 		var js_url  = ta.src;
			// 		var url = '//ad.toutiao.com/link_monitor/cdn_failed?web_url=' + web_url + '&js_url=' + js_url + '&convert_id=1614024739832855';
			// 		request.open('GET', url, true);
			// 		request.send(null);
			// 	}
			// 	var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ta, s);
			// })(window);

			//说明头条
			//   (function(root) {
			// 	root._tt_config = true;
			// 	var ta = document.createElement('script'); ta.type = 'text/javascript'; ta.async = true;
			// 	ta.src = document.location.protocol + '//' + 's1.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
			// 	ta.onerror = function () {
			// 		var request = new XMLHttpRequest();
			// 		var web_url = window.encodeURIComponent(window.location.href);
			// 		var js_url  = ta.src;
			// 		var url = '//ad.toutiao.com/link_monitor/cdn_failed?web_url=' + web_url + '&js_url=' + js_url + '&convert_id=1614024739832855';
			// 		request.open('GET', url, true);
			// 		request.send(null);
			// 	}
			// 	var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ta, s);
			// })(window);

			//百度信息流
			window._agl = window._agl || [];
			(function () {
				_agl.push(
					['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
				);
				(function () {
					var agl = document.createElement('script');
					agl.type ='text/javascript';
					agl.async = true;
					agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
					var s = document.getElementsByTagName('script')[0];
					s.parentNode.insertBefore(agl, s);
				})();
			})();

			//广点通
			!function(g,d,t,e,v,n,s){if(g.gdt)return;v=g.gdt=function(){v.tk?v.tk.apply(v,arguments):v.queue.push(arguments)};v.sv='1.0';v.bt=0;v.queue=[];n=d.createElement(t);n.async=!0;n.src=e;s=d.getElementsByTagName(t)[0];s.parentNode.insertBefore(n,s);}(window,document,'script','//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js');
			gdt('init','1107859393');
			gdt('track','PAGE_VIEW');


			String.prototype.GetValue = function (para) {
				var reg = new RegExp("(^|&)" + para + "=([^&]*)(&|$)");
				var r = this.substr(this.indexOf("\?") + 1).match(reg);
				if (r != null && r[2].indexOf("#") > 0) {
					r[2] = r[2].substring(0, r[2].indexOf("#"));
				}
				if (r != null) return decodeURI(r[2]); return null;
			};
		},
		methods: {
			webReady: function() {
				var self = this;
				if(self.$route.query.cityPy) {
					self.cityPy = self.$route.query.cityPy
				}
				if(self.$route.query.activityType){
					self.periodsType=self.$route.query.activityType;
				}
				self.initpageDate();
				$(window).scroll(function() {
					if($(window).scrollTop() > $(".formwrap").offset().top) {
						$(".fixedSubmit").show();
					} else {
						$(".fixedSubmit").hide();
					}
				});
			},
			commonT:function(){
				gdt('track', 'RESERVATION', {'key1': 'value1', 'key2': 'value2'});
				// _taq.push({convert_id:"1614024739832855", event_type:"form"});
				window._agl && window._agl.push(['track', ['success', {t: 3}]]);
				// _taq.push({convert_id: "1614024739832855", event_type: "form"});
				// _taq.push({convert_id:"1614024739832855", event_type:"form"});
			},
			tojiIcpc:function(ocpcId){
				var ocpcId = ocpcId;
				(function (root) {
					root._tt_config = true;
					var ta = document.createElement('script'); ta.type = 'text/javascript'; ta.async = true;
					ta.src = document.location.protocol + '//' + 's3.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
					ta.onerror = function () {
						var request = new XMLHttpRequest();
						var web_url = window.encodeURIComponent(window.location.href);
						var js_url = ta.src;
						var url = '//ad.toutiao.com/link_monitor/cdn_failed?web_url=' + web_url + '&js_url=' + js_url + '&convert_id=' + ocpcId;
						request.open('GET', url, true);
						request.send(null);
					}
					var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ta, s);
				})(window);
			},
			getTime: function() {
				var self = this;
				/* 按24小时循环倒计时 */
				var endTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 -1);
				var currentTime = new Date(new Date().getTime());
				var diffTime = endTime - currentTime;
				self.cutTimePre = diffTime;
				/* end */
				//计算出相差天数
				// var days = Math.floor(self.cutTimePre / (24 * 3600 * 1000))
				//计算出小时数
				var leave1 = self.cutTimePre % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
				var hours = Math.floor(leave1 / (3600 * 1000))
				//计算相差分钟数
				var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
				var minutes = Math.floor(leave2 / (60 * 1000))
				//计算相差秒数
				var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
				var seconds = Math.round(leave3 / 1000);
				/*if(self.day != days) {
					self.day = days;
				}*/
				if(self.hour != hours) {
					self.hour = hours;
				}
				if(self.min != minutes) {
					self.min = minutes;
				}
				if(self.sec != seconds) {
					self.sec = seconds;
				}
				// if(self.cutTimePre > 0) {
				// 	var self = this;
				// 	self.cutTimePre = self.cutTimePre - 1000;
					setTimeout(function() {
						self.getTime();
						if(self.cutTimePre <= 0) {
							//倒计时结束
							alert('倒计时结束');
						}
					}, 1000);
				// }
			},
			getTimeMsec:function(){
				var timer = '', self = this;
				// if(self.cutTimePre < 0){ clearInterval(timer); self.msec = 0; }
				timer = setInterval(function(){
					if(self.msec==0){
						self.msec = 10;
					}
					self.msec--;
				},100);
			},
			initpageDate: function() {
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.initpagedata + '/' + self.$route.query.cityPy + '?periodsType=' + self.periodsType + '&autoShowContentType=' + 9,
					type: "post",
					data: {},
					async: false,
					dataType: 'json',
					success: function(data) {
						if(data.responseHeader.status == 200) {
							self.showAddress = data.response.result.address;
							console.log(self.showAddress);
							document.title = data.response.result.periodsInfo.title;
							window.cityId = data.response.result.periodsInfo.cityId;
							self.appPersonNum = data.response.result.concentMap.appPersonNum;
							if(data.response.result.concentMap.autoShowInfo) {
								self.autoShowInfo = data.response.result.concentMap.autoShowInfo;
								self.headerIntroList = data.response.result.concentMap.autoShowInfo.headerIntroList;
								self.autoShowInfo.headerImg = data.response.result.concentMap.autoShowInfo.headerImg;
								self.autoShowInfo.headerImgb = data.response.result.concentMap.autoShowInfo.headerImgb;
								self.autoShowInfo.headerImgc = data.response.result.concentMap.autoShowInfo.headerImgc;
								self.autoShowInfo.presentList = self.autoShowInfo.presentList;
								var maps = {};
								for(var i = 0; i < self.autoShowInfo.presentList.length; i++) {
									if(!maps[self.autoShowInfo.presentList[i].labelType]) {
										maps[self.autoShowInfo.presentList[i].labelType] = 1;
									}
								}
								self.autoShowInfo.maps = maps;
							}
							self.applyListMap = data.response.result.applyListMap;
							self.setApplyListMap(); //报名人数
							self.brandList = data.response.result.periodsInfo.exhibitionBrandList;
							self.brandNum = Math.ceil(data.response.result.periodsInfo.exhibitionBrandList.length / 12);
							self.periodsInfo = data.response.result.periodsInfo;
							self.periodsType = data.response.result.periodsInfo.activityType;
							// self.cutTimePre = data.response.result.periodsInfo.endTime - data.responseHeader.timestamp;
							self.getTime(); //调用倒计时
							self.getTimeMsec();
							//							self.autoShowInfo.presentList = data.response.result.concentMap.autoShowInfo.presentList;
							setTimeout(function(){
								self.scrollSwiperitem("#giftSwiper");
								self.scrollSwiperitem("#signinSwiper");
								self.scrollSwiperitem("#sharSwiper");
							},0);
							getCommonJsIns.loadJs(getCommonJsIns.scriptUrl["kxbdmarquee"], function() {
								self.kxbdMarq("#scrollsize");
								self.kxbdMarq("#scrollPerson");
								//增加ocpcId
								if(data.response.result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc != null) {
									self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId = data.response.result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
									self.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal = data.response.result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal;
									self.tojiIcpc(self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId);
								};

							});
						} else {
							if(data.response.result.cityId){
								window.cityId = data.response.result.cityId;
							}else{
								window.cityId = self.cityId;
							}
            				window.location.href=SIGNTUREURL.signURL+'/bmtcj?cityId='+window.cityId;
						}
					},
					error: function(data) {
						if(data.response.result.cityId){
							window.cityId = data.response.result.cityId;
						}else{
							window.cityId = self.cityId;
						}
						window.location.href=SIGNTUREURL.signURL+'/bmtcj?cityId='+window.cityId;
					}
				})
			},
			kxbdMarq: function(obj) {
				$(obj).kxbdMarquee({
					direction: "up",
					isEqual: false,
					scrollDelay: 40,
					loop: 0
				});
			},
			scrollSwiperitem: function(id) {
				var giftSwiper = new Swiper(id, {
					/*pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},*/
					// pagination: '.swiper-pagination',
					initialSlide: 0,
					slidesPerView: 4, //4列
					spaceBetween: 10, //距离
					observeParents: true, //修改swiper的父元素时，自动初始化swiper  
					observer: true //修改swiper自己或子元素时，自动初始化swiper 
				});
				//定时
				//				if(giftSwiper){
				//				  setTimeout(function() {
				//					 giftSwiper.slideTo(0, 20, false);
				//				   }, 20)
				//				}

			},
			showMask: function() {
				var self = this;
				self.masklayer = true;
				self.popshaned = true;
			},
			colsemask: function() {
				var self = this;
				self.masklayer = false;
				self.popshaned = false;
			},
			showbrandmask: function(url, title, brandId) {
				var self = this;
				self.url = url;
				self.title = title;
				self.brandId = brandId;
				self.masklayer = true;
				self.brandMask = true;
			},
			closebrandMask: function() {
				var self = this;
				self.masklayer = false;
				self.brandMask = false;
			},
			addxydetail: function() {
				// $(".xymarsk").show();
				// $(".addxypop-mark").show();
				// $('html').css({
				// 	"overflow-y": "hidden"
				// });
				// $('body', 'html').css({
				// 	"position": "fixed",
				// 	"left": "50%",
				// 	"margin-left": "-5rem",
				// 	"top": 0
				// });
      			agreementUtil.agreement.init();

			},
			sinSubmit: function(objId) {
				var self = this;
				if($("#insertCar").text() == "请选择意向品牌或车型") {
					Toast('请选择意向品牌或车型');
				} else if(!self.phone) {
					Toast('请输入手机号');
				} else if(!webCommonUtil.commonFun.isPhone(self.phone)) {
					Toast('请输入正确的手机号');
				} else if(!self.username) {
					Toast('请输入姓名');
				} else if(!webCommonUtil.commonFun.isName(self.username)) {
					Toast('请输入正确的姓名');
				} else {
					self.isclick=true;
					self.applySub(objId);
				}
			},
			applySub: function(objId) {
				var self = this;
				self.isLading = true;
				var curWindow = window.location.href;
				var data = {
					"phone": self.phone,
					"name": self.username,
					"sourceUrl": curWindow,
					"noCheckBrandStyle": 1,
					"cityId": self.periodsInfo.cityId,
					'groupbyType': self.periodsType,
					'groupbyNum': self.periodsInfo.id,
					"sourceId":'-1',
					"bmtype":'red_apply'
				}
				data["brandId"] = $(objId).data("brandId");
				data["carStyleId"] = $(objId).data("carstyleId");

				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
					type: "post",
					data: data,
					async: false,
					dataType: 'json',
					success: function(data) {
						self.commonT();
						if(data.responseHeader.status == 200) {
							self.isclick=false;
							var c = document.location.href.GetValue("c");
							if(self.autoShowInfo.tAutoshowPeriodsOcpc != null && c == self.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal) {
								var id = self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
								if(id != "") {
										_taq.push({
											convert_id: id,
											event_type: "form"
										});
								}
							}
							self.isLading = false;
							self.phone = "";
							self.username = "";
							$('#insertCar').text('请选择意向品牌或车型');
							window.location.href = "/hmtcj/applySupplement?address=" + $("#showAddress").val() + "&applyId=" + data.response.result.result.applyId + "&t=" + Date.parse(new Date()) + "&buyway=0&instalments=0&otherbrand=0&periodsId=" + $('#groupbyNum').val() + "&cityId=" + cityId + "&sk=" + data.response.result.result.sk;
						} else {
							console.log("请求失败");
						}
					},
					error: function() {
						console.log('error');
						self.isLading = false;
						self.isclick=false;
					}
				})
			},
			getData: function(event) {
				webCommonUtil.getBrandCarStyle.init({
					domObj: event.target,
					callback: function() {
						//console.log($("#aa").data("carstyleiName"));
					},
					ajaxBrandParams: {
						url: this.commmonWebConfig.tuancheapi + this.ajaxSubmit.allUrl.tcBrand,
						type: "post",
						dataType: "json",
						async: false,
						data: {
							cityId: window.cityId
						}
					},
					ajaxCarStyleParams: {
						url: this.commmonWebConfig.tuancheapi + this.ajaxSubmit.allUrl.baseDataTcStyle,
						type: "post",
						dataType: "json",
						async: false,
						data: {
							cityId: window.cityId
						}
					}
				});
			},
			setApplyListMap: function() {
				var compare = function(x, y) { //比较函数
					if(x.num < y.num) {
						return -1;
					} else if(x.num > y.num) {
						return 1;
					} else {
						return 0;
					}
				}
				for(var i = 0; i < this.applyListMap.length; i++) {
					var num = parseInt(Math.random() * 60, 10) + 1;
					this.applyListMap[i].time = num + "分钟前";
					this.applyListMap[i].num = num;
				}
				this.applyListMap = this.applyListMap.sort(compare);
			},
			maskSubmit: function(maskobjId) { //底部弹窗
				var self = this;
				if($("#insertCarmask").text() == "请选择意向品牌或车型") {
					Toast('请选择意向品牌或车型');
				} else if(!self.maskPhone) {
					Toast('请输入手机号');
				} else if(!webCommonUtil.commonFun.isPhone(self.maskPhone)) {
					Toast('请输入正确的手机号');
				} else if(!self.maskName) {
					Toast('请输入姓名');
				} else if(!webCommonUtil.commonFun.isName(self.maskName)) {
					Toast('请输入正确的姓名');
				} else {
					self.isMaskclick=true;
					self.maskSinapply(maskobjId);
				}
			},
			maskSinapply: function(maskobjId) { //底部弹窗报名
				var self = this;
				self.isLading = true;
				var data = {
					"phone": self.maskPhone,
					"name": self.maskName,
					"sourceUrl": curWindow,
					"noCheckBrandStyle": 1,
					"cityId": self.periodsInfo.cityId,
					"groupbyType": self.periodsType,
					'groupbyNum': self.periodsInfo.id,
					"checkIp": false,
					"sourceId":'-1',
					"bmtype":'red_apply'
				}
				data["brandId"] = $(maskobjId).data("brandId");
				data["carStyleId"] = $(maskobjId).data("carstyleId");
				var curWindow = window.location.href;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
					type: "post",
					data: data,
					async: false,
					dataType: 'json',
					success: function(data) {
						self.commonT();
						if(data.responseHeader.status == 200) {
							self.isMaskclick=false;
							var c = document.location.href.GetValue("c");
							if(self.autoShowInfo.tAutoshowPeriodsOcpc != null && c == self.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal) {
								var id = self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
								if(id != "") {
										_taq.push({
											convert_id: id,
											event_type: "form"
										});
								}
							}
							self.isLading = false;
							self.maskPhone = "";
							self.maskName = "";
							$('#insertCarmask').text('请选择意向品牌或车型');
							self.masklayer = false;
							self.popshaned = false;
							window.location.href = "/hmtcj/applySupplement?address=" + $("#showAddress").val() + "&applyId=" + data.response.result.result.applyId + "&t=" + Date.parse(new Date()) + "&buyway=0&instalments=0&otherbrand=0&periodsId=" + $('#groupbyNum').val() + "&cityId=" + cityId + "&sk=" + data.response.result.result.sk;
						} else {
							console.log("请求失败");
						}
					},
					error: function() {
						console.log('error');
						self.isLading = false;
						self.isMaskclick=false;
					}
				})
			},
			brandmaskSubmit: function() { //品牌弹窗报名
				var self = this;
				if(!self.brandPhone) {
					Toast('请输入手机号');
				} else if(!webCommonUtil.commonFun.isPhone(self.brandPhone)) {
					Toast('请输入正确的手机号');
				} else if(!self.brandName) {
					Toast('请输入姓名');
				} else if(!webCommonUtil.commonFun.isName(self.brandName)) {
					Toast('请输入正确的姓名');
				} else {
					var self = this;
					self.isLading = true;
					var curWindow = window.location.href;
					self.ajaxSubmit.ajax({
						url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
						type: "post",
						data: {
							"phone": self.brandPhone,
							"name": self.brandName,
							"sourceUrl": curWindow,
							"noCheckBrandStyle": 1,
							"cityId": self.periodsInfo.cityId,
							"groupbyType": self.periodsType,
							'brandId': self.brandId, //品牌id
							'groupbyNum': self.periodsInfo.id,
							"sourceId":'-1',
							"bmtype":'red_apply'
						},
						async: false,
						dataType: 'json',
						success: function(data) {
							self.commonT();
							if(data.responseHeader.status == 200) {
								var c = document.location.href.GetValue("c");
								if(self.autoShowInfo.tAutoshowPeriodsOcpc != null && c == self.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal) {
									var id = self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
									if(id != "") {
											_taq.push({
												convert_id: id,
												event_type: "form"
											});
									}
								}
								self.isLading = false;
								Toast('领票成功');
								self.brandPhone = "";
								self.brandName = "";
								self.masklayer = false; //关闭弹窗蒙层
								self.brandMask = false;
								window.location.href = "/hmtcj/applySupplement?address=" + $("#showAddress").val() + "&applyId=" + data.response.result.result.applyId + "&t=" + Date.parse(new Date()) + "&buyway=0&instalments=0&otherbrand=0&periodsId=" + $('#groupbyNum').val() + "&cityId=" + cityId + "&sk=" + data.response.result.result.sk;
							} else {
								console.log("请求失败");
							}
						},
						error: function() {
							console.log('error');
						}
					})
				}
			}
		}
	}
</script>
<noscript>
	<img height="1" width="1" style="display:none" src="https://a.gdt.qq.com/pixel?user_action_set_id=1107859393&action_type=PAGE_VIEW&noscript=1"/>
</noscript>


// WEBPACK FOOTER //
// src/views/threecity/threecityindex.vue